import { fetchWallets } from "@/entities/community"
import { fetchTradingWallet } from "@/entities/trading"
import { useTransferBonusesModal } from "@/features/trading"
import { useAppDispatch } from "@/shared/lib/redux"

export const DebitButton = () => {
    const dispatch = useAppDispatch()
    const { openTransferBonusesModal } = useTransferBonusesModal()

    const onDebit = () => {
        dispatch(fetchWallets())
        dispatch(fetchTradingWallet())
    }

    return (
        <button 
            className="font-mediumttf text-[18px] text-white"
            onClick={() => openTransferBonusesModal(onDebit)}
        >
            Вывести
        </button>
    )
}